import MetaTags from "./index";
import { defaultMetatags } from "@/lib/constants";
import config from "@/lib/config";
import routes from "@/lib/routes";

export function tags(title) {
  const keywords =
    title?.meta_keywords && title?.meta_keywords.length > 0
      ? title.meta_keywords.join(",")
      : null;

  return {
    title: `${title.name}の動画一覧 | SPOOX(スプークス)`,
    keywords: keywords || defaultMetatags.vod.keywords,
    description: `${title.name}の動画一覧 。SPOOX(スプークス)では、スポーツや映画やアニメ、音楽ライブなど、様々な動画を配信中！月額見放題でも、1作品から購入でも楽しめます。`,
    og: {
      type: "article",
      url: `${config.host.vod}${routes.title(title.id)}`,
    },
    twitter: {
      card: "summary",
    },
  };
}

export default function TitleMetaTags({ title }) {
  const props = tags(title);
  return <MetaTags {...props} />;
}
